//React Components and Hooks
//Material UI Components
import Box from "@mui/material/Box";
//Material UI functions
import { makeStyles } from "@mui/styles";
import TableRow from "@mui/material/TableRow";
import React, { useState } from "react";
import Cancel from "../../elements/Icons/Cancel";
import Delete from "../../elements/Icons/Delete";
//Custom Components
import UbilCell from "./Cell";

const UbilRow = (props) => {
  const useStyles = makeStyles((theme) => {
    return {};
  });
  const classes = useStyles();
  const [deleteRow, setDeleteRow] = useState(false);
  const {
    columns,
    data,
    rowType,
    rowFunction,
    deleteFunction,
    cancelDeleteFunction,
    deleteField,
    destination,
    linkField,
  } = props;

  switch (rowType) {
    case "clickable":
      return (
        <TableRow
          onClick={() => {
            const win = window.open(
              `${destination}/${data[linkField]}`,
              "_blank"
            );
            win.focus();
          }}
          key={data.id}
          hover
          tabIndex={-1}
        >
          {columns.map((column, index) => (
            <UbilCell column={column} data={data} key={index} />
          ))}
        </TableRow>
      );
    case "deletable":
      let deleteClickHandler = () => {
        setDeleteRow(true);
        deleteFunction();
      };
      let cancelClickHandler = () => {
        setDeleteRow(false);
        cancelDeleteFunction();
      };
      return (
        <TableRow
          style={{ backgroundColor: deleteRow ? "red" : "white" }}
          key={props.id}
          hover
          tabIndex={-1}
        >
          {columns.map((column, index) => (
            <UbilCell column={column} data={data} key={index}>
              {column.type === "icons" ? (
                <Box>
                  {deleteRow ? (
                    <Cancel
                      tooltip="CANCEL"
                      clickFunction={cancelClickHandler}
                    />
                  ) : (
                    <Delete
                      tooltip="DELETE"
                      clickFunction={deleteClickHandler}
                    />
                  )}
                </Box>
              ) : (
                ""
              )}
            </UbilCell>
          ))}
        </TableRow>
      );
    default:
      return (
        <TableRow key={props.id} hover tabIndex={-1}>
          {columns.map((column, index) => (
            <UbilCell column={column} data={data} key={index} />
          ))}
        </TableRow>
      );
  }
};
export default UbilRow;
